<template>
  <div style="background: #fff">
    <CHeader
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    >
      <CHeaderBrand class="mx-auto" to="/">
        <img
          src="../../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-md-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <!-- <CDropdownItem
          style="width: 100% !important"
          href="https://pickiddo.com/about"
        >
          ABOUT US</CDropdownItem
        >
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://pickiddo.com/Tuition/UserGuide"
          >TUTORIAL</CDropdownItem
        > -->
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
           <CDropdownItem to="/SearchTutor">REGISTER</CDropdownItem>
        <CDropdownItem to="/Partner">JOIN AS PARTNER</CDropdownItem>
        <CDropdownItem to="/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >PARTNER LOGIN</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Partner">
            JOIN AS PARTNER
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink to="/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>

    <div>
      <!-- <h1 class="custom-font text-center">SEARCH TUTOR</h1>
      <h5 class="custom-font text-center">Find tutor for your children</h5>
      <br /><br /> -->
      <!-- <CContainer>
        <CCard>
          <CCol sm="12" lg="12">
            <CRow class="m-2">
              <CCol sm="6" lg="6">
              
              </CCol>
              <CCol sm="6" lg="6">
                <h5 class="custom-font mt-2">
                 Install Pickiddo Apps ans start to connect with your tutor
                </h5>
                <div class="text-center">
                 <a
                    href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                  >
                    <img
                      style="max-width: 150px"
                      class="mt-2 mb-2"
                      src="../assets/img/gp2black.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/pickiddo/id1366167288">
                    <img
                      style="max-width: 150px"
                      class="ml-2 mt-2 mb-2"
                      src="../assets/img/gpblack.png"
                    />
                  </a>
                </div>
                  <div style="width: 100%; height: 20px; border-bottom: 1px solid black; text-align: center" class="mb-4">
      <span style="font-size: 15px; background-color: #fff; padding: 0 10px;">
       OR
      </span>
    </div>
     <h5 class="custom-font mt-2">Contact Us</h5>
                <v-select
                  v-model="SelectedGrade"
                  :options="grades"
                  label="GradeName"
                  placeholder="--Please Select Level--"
                  required
                ></v-select>

                <CInput type="text" v-model="Name" placeholder="Enter your Name" class="mt-3"/>

                <CInput type="text" v-model="PhoneNumber" placeholder="Enter your Phone Number (example:0123344567)" class="mt-2"/>

                <CButton color="success" block
                @click="InsertFindTutor"
                >
               SUBMIT</CButton>
                <div class="text-center">
                  <CButton color="link" class="px-0 mt-2"
                    ><CHeaderNavLink to="/">Back to homepage</CHeaderNavLink></CButton
                  >
                </div>
              </CCol>
            </CRow>
          </CCol>
         
        </CCard>
         <CCol sm="12" lg="12" class="text-center">
            
          </CCol>
      </CContainer> -->
    </div>




    <CCol sm="12" lg="12">
    <CRow>
       <CCol sm="6" style="background-size:cover;color:#fff" :style="{ backgroundImage: `url(${backgroundCount})`}">
        <CCol sm="12" lg="12">
          <img src="../../assets/img/Logo.png" width="50px" class="ml-2 mt-2"/> <span class="font-xl ml-2 mt-4">Pickiddo</span>
        </CCol>
        <div class="c-app flex-row align-items-center text-white" style="margin-top:-60px;background:none">
          <CContainer>
            <CRow class="justify-content-center">
              <CCol sm="10" lg="10">
                <div>
                 
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </CCol>
      <CCol sm="6">
        <div style="margin-top:0px;background:#fff" class="c-app flex-row align-items-center">
          <CContainer class="p-5">
            <CRow class="justify-content-left">
              <CCol sm="10" lg="10">
                  <h5 class="custom-font mt-2">
                 Install Pickiddo Apps ans start to connect with your tutor
                </h5>
                <div class="text-center">
                 <a
                    href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                  >
                    <img
                      style="max-width: 150px"
                      class="mt-2 mb-2"
                      src="../../assets/img/gp2black.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/pickiddo/id1366167288">
                    <img
                      style="max-width: 150px"
                      class="ml-2 mt-2 mb-2"
                      src="../../assets/img/gpblack.png"
                    />
                  </a>
                </div>
                 <div style="width: 100%; height: 20px; border-bottom: 1px solid black; text-align: center" class="mb-4">
      <span style="font-size: 15px; background-color: #fff; padding: 0 10px;">
       OR
      </span>
    </div>
     <h5 class="custom-font mt-2">Contact Us</h5>
                <v-select
                  v-model="SelectedGrade"
                  :options="grades"
                  label="GradeName"
                  placeholder="--Please Select Level--"
                  required
                ></v-select>

                <CInput type="text" v-model="Name" placeholder="Enter your Name" class="mt-3" size="lg"/>

                <CInput type="text" v-model="PhoneNumber" placeholder="Enter your Phone Number (example:0123344567)" class="mt-2"  size="lg"/>

                <CButton color="success" block size="lg"
                @click="InsertFindTutor"
                >
               SUBMIT</CButton>
                <div class="text-center">
                  <CButton color="link" class="px-0 mt-2"
                    ><CHeaderNavLink to="/">Back to homepage</CHeaderNavLink></CButton
                  >
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </CCol>
    </CRow>
  </CCol>
    <div style="background: #f1efef">
      <CContainer>
        <CCol sm="12" lg="12" class="p-5">
          <CRow>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">PREFACE</h5>
              <br />
              <label class="custom-font"
                >A cloud based platform designed to help tuition center to
                control and manage their administration in more efficient with
                smart search feature that more flexible to retrieve records.
                Pickiddo helps to manage students' payment and issues official
                receipts without any hassle.</label
              >
              <a href="https://www.facebook.com/pickiddo">
                <img width="30px" src="../../assets/img/fb1.png" />
              </a>
              <a href="https://twitter.com/pickiddo?lang=en">
                <img width="30px" class="ml-1" src="../../assets/img/tw.png" />
              </a>
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <img width="30px" class="ml-1" src="../../assets/img/in.png" />
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong> COMPANY </strong>
              </h5>
              <br />
              <a href="https://pickiddo.com/about"
                ><h6 class="text-black custom-font">ABOUT US</h6></a
              >
              <br />
              <a href="https://pickiddo.com/Contact">
                <h6 class="text-black custom-font">CONTACT US</h6></a
              >
              <br />
              <a href="https://pickiddo.com/Blog"
                ><h6 class="text-black custom-font">BLOG</h6></a
              >
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>COMMUNITY</strong>
              </h5>
              <br />
              <a href="https://www.facebook.com/pickiddo"
                ><h6 class="text-black custom-font">FACEBOOK</h6></a
              >
              <br />
              <a href="https://twitter.com/pickiddo?lang=en">
                <h6
                  class="text-black custom-font"
                  href="https://twitter.com/pickiddo?lang=en"
                >
                  TWITTER
                </h6>
              </a>
              <br />
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <h6 class="text-black custom-font">INSTAGRAM</h6>
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>TERM PRIVACY</strong>
              </h5>
              <br />
              <a>
                <CHeaderNavLink to="/Legal">
                  <h6 class="text-black custom-font">TERMS AND CONDITION</h6></CHeaderNavLink
                >
              </a>
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </div>
  </div>
</template>

    
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import backgroundUrl from "../../assets/img/bgcontact.png";
import backgroundUrlApps from "../../assets/img/bg3Copy-1.png";
import backgroundCount from "../../assets/img/Landingpage.png";

import video from "../../assets/img/app3.mp4";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import _ from "lodash";



export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      successModal: false,
      CustomerName: "",
      CustomerEmail: "",
      CustomerPhoneNumber: "",

      backgroundUrl,
      backgroundCount,
      backgroundUrlApps,
      view: {
        topOfPage: true,
      },

      video,

      slides: 7,
      autoplay: true,
      loop: true,
      playerOptions: {
        loop: true,
        autoplay: true,
      },
      autoplay: {
        // automatically play the video
        type: Boolean,
        default: () => true,
      },
      loop: {
        // loop the video infinitely
        type: Boolean,
        default: () => true,
      },
      cardList: false,
      toggle: false,
        SelectedGrade: "",
        grades: [],

        Name: "",
        PhoneNumber: "",
    };
  },
  created() {
    AOS.init();
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    this.GetGrade();
  },
  methods: {
       async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    InsertFindTutor() {
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("PhoneNumber", this.PhoneNumber);
      formData.append("LevelId", this.SelectedGrade.Id);

      return this.$API
        .post(this.$InsertFindTutors, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("Thanks for your interest.")
              .then(function (dialog) {
                console.log("Closed");
              });
              this.GotoWhatsap();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },

     GotoWhatsap() {
     location.replace("https://wa.me/600106597700?text=+Hi, My name is " + this.Name + ' and my number is ' + this.PhoneNumber + ' would like to know more details about search tutor ');
    },

    navbarShow() {
      this.cardList = true;
    },
    GoToPagePro() {
      this.$router.push("/ProClass");
    },
    GotoLogin() {
      this.$router.push("https://pickiddo.com/TuitionCenter/Login");
    },
    GotoApple() {
      this.$router.push("https://apps.apple.com/my/app/pickiddo/id1366167288");
    },
    GotoGoogle() {
      this.$router.push(
        "https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
      );
    },

    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
    },
    onBeforeSlideChange(index) {
      console.log(
        "@onBeforeSlideChange Callback Triggered",
        "Slide Index " + index
      );
    },
    onLastSlide(index) {
      console.log("@onLastSlide Callback Triggered", "Slide Index " + index);
    },
  },
};
</script>
<style>
body {
  background: #fff;
   font-family: "Rubik", sans-serif;

}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

.form-control-lg {
    height: calc(1.5em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 1em;
    line-height: 1.5;
    border-radius: 0.3rem;
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300&display=swap");
</style>
